import UserNewsTips from './UserNewsTips'

export default UserNewsTips
